module.exports = __webpack_public_path__ + "static/neuseeland-83616b527ca10724c0af35e7bdd55185.svg";